import './reports.css';

const plural = (count) => `${count} report${count === 1 ? '' : 's'}`;

/** Sticks to the bottom of the screen while reports are selected. */
const BulkActionBar = ({
  count,
  readers,
  targetReaderId,
  onTargetChange,
  onCopy,
  onMove,
  onDelete,
  onSelectAll,
  allSelected,
  working
}) => (
  <div className="report-bulk-bar" role="region" aria-label="Selected reports">
    <div className="report-bulk-top">
      <span className="report-bulk-count">{count === 0 ? 'Select reports' : `${plural(count)} selected`}</span>
      <button type="button" className="report-link" onClick={onSelectAll}>
        {allSelected ? 'Clear all' : 'Select all loaded'}
      </button>
    </div>

    {count > 0 && (
      <div className="report-bulk-actions">
        {readers.length > 1 && (
          <div className="report-bulk-readers">
            <label htmlFor="report-bulk-reader" className="sr-only">Reader</label>
            <select
              id="report-bulk-reader"
              value={targetReaderId}
              onChange={(e) => onTargetChange(e.target.value)}
              disabled={working}
            >
              <option value="">Reader…</option>
              {readers.map((reader) => (
                <option key={reader.id} value={reader.id}>{reader.name}</option>
              ))}
            </select>
            <button
              type="button"
              className="report-btn"
              onClick={onCopy}
              disabled={!targetReaderId || working}
              title="Log these chapters for this reader too, on the same days"
            >
              Also log
            </button>
            <button
              type="button"
              className="report-btn"
              onClick={onMove}
              disabled={!targetReaderId || working}
              title="Log these chapters for this reader instead"
            >
              Move
            </button>
          </div>
        )}
        <button
          type="button"
          className="report-btn report-btn--danger"
          onClick={onDelete}
          disabled={working}
        >
          Delete {count}
        </button>
      </div>
    )}
  </div>
);

export default BulkActionBar;
